

export const TECHNICIAN_COURSES_INITIATE_FETCH_COURSES_LIST  = 'TECHNICIAN_COURSES_INITIATE_FETCH_COURSES_LIST';
export const TECHNICIAN_COURSES_FETCH_COURSES_LIST_START = 'TECHNICIAN_COURSES_FETCH_COURSES_LIST_START';
export const TECHNICIAN_COURSES_FETCH_COURSES_LIST_SUCCESS = 'TECHNICIAN_COURSES_FETCH_COURSES_LIST_SUCCESS';
export const TECHNICIAN_COURSES_FETCH_COURSES_LIST_FAIL = 'TECHNICIAN_COURSES_FETCH_COURSES_LIST_FAIL';
export const TECHNICIAN_COURSES_FETCH_COURSES_LIST_RESET = 'TECHNICIAN_COURSES_FETCH_COURSES_LIST_RESET';